import { __decorate, __metadata } from 'tslib';
import { InjectorService } from '@tencent/ioc';
import { ProxyRegistry } from '@tencent/workbench-core';
import { Service } from '../../decorators/class/service.js';
import { MiddlewareRegistry } from '../../registries/middleware-registry.js';

/**
 * 中间件服务
 *
 * @public
 */
let MiddlewareService = class MiddlewareService extends ProxyRegistry {
    constructor() {
        super(MiddlewareRegistry);
    }
    $onInit() {
        InjectorService.buildRegistry(MiddlewareRegistry);
    }
    invoke(target) {
        return InjectorService.invoke(target);
    }
    /**
     * 增加一个全局中间件，需指定生效 UI 服务和回调方法
     *
     * @param middleware - 中间件
     * @param options - 中间件选项
     */
    use(middleware, options) {
        const service = InjectorService.get(options.on);
        options.callbackNames.forEach((callbackName) => {
            service.use(middleware, callbackName);
        });
    }
};
MiddlewareService = __decorate([
    Service(),
    __metadata("design:paramtypes", [])
], MiddlewareService);

export { MiddlewareService };
//# sourceMappingURL=middleware-service.js.map
